export enum Spacing {
  Micro = 4,
  Small = 8,
  Medium = 12,
  Large = 16,
  xLarge = 24,
  xxLarge = 32,
}
